// extracted by mini-css-extract-plugin
module.exports = {"section":"what-is_section__pryDL","title":"what-is_title__K1z4R","link":"what-is_link__1PEU0"};